import "./AppStyle.css"


export default function TodosList({todes,setTodes,setEditTodo}){


    const handlerDelete = ({id}) =>{
       
       // eslint-disable-next-line no-restricted-globals
       if(confirm("هل بالفعل تريد حذفها؟") ){
         return setTodes(todes.filter(todo => todo.id !== id)) 
       
       }
   
    }

    const handlerComplete = (todo)=>{
   
      
        setTodes(todes.map((item) =>{
            if(item.id === todo.id){
                alert("احسنت انجاز المهمة !")
                return( { ...item , completed: !item.completed}
                  
                   
                 
                )
                

            }
            return item 
 
          
        })
   )
}

    const handlerEdit = ({id})=>{
        const findTodo = todes.find(todo => todo.id === id)
        setEditTodo(findTodo)
    }

    return(
        <div>
            {todes.map((todo) =>(
                <li key={todo.id} className="list-none w-[18rem] h-8 mt-[1rem] mr-8 border-solid border-2 border-[#5f7c89] rounded-md">

                     <input  type="text" readOnly value={todo.title} onChange={(event)=>event.preventDefault()}
                     className={`bg-inherit text-white  outline-none mr-[8px] ${todo.completed ? "complete" :""} `} />
            
                
                     
                     <button className="text-green-500 mr-2" onClick={()=> handlerComplete(todo)}><i class="fa-solid fa-circle-check"></i></button>
                     <button className="text-yellow-500 mr-2"onClick={()=> handlerEdit(todo)}><i class="fa-regular fa-pen-to-square"></i></button>
                     <button className="text-red-500 mr-2" onClick={()=> handlerDelete(todo)}><i class="fa-solid fa-trash"></i> </button>
                </li>
              
                    

               
            )
        

            )}



        </div>
    )
}